import { ImageType } from "entities/common";
import { DELETE, POST } from "utils/http";

const baseUrl = "/api/portfolios";

export const upload = (portfolioId: number, files: File[]) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  return POST<FormData, ImageType[]>(`${baseUrl}/${portfolioId}/images`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const remove = (portfolioId: number, imageId: number) =>
  DELETE(`${baseUrl}/${portfolioId}/images/${imageId}`);
